import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type GymGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

/**
 * Shows children only when sauna module is enabled in module config.
 */
export const GymGate: React.FC<GymGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { gym } = useModuleConfig()
  return gym.enabled ? children : <Navigate to={redirectTo} replace />
}
